import { UIStore } from './UIStore'
import { ProfileStore } from './ProfileStore'
import { DynamicCatalogStore } from './DynamicCatalogStore'
import { SingleCatalogStore } from './SingleCatalogStore'

export const store = {
  ui: new UIStore(),
  profile: new ProfileStore(),
  dynamicCatalog: new DynamicCatalogStore(),
  singleCatalog: new SingleCatalogStore(),
}
